
import { useEffect, useRef } from 'react';
import { useTasks } from '@/context/TaskContext';

export const useRealTimeTaskUpdate = (isRunning: boolean, timerType: string) => {
  const { activeTask, updateTask } = useTasks();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Only track time for pomodoro sessions
    if (isRunning && timerType === 'pomodoro' && activeTask) {
      console.log('Starting real-time task time tracking for:', activeTask.title);
      
      // Clear any existing interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      // Update task time every second
      intervalRef.current = setInterval(() => {
        console.log('Updating task time in real-time');
        
        // Update task time by 1 second
        const updatedTask = {
          ...activeTask,
          totalTimeSpent: activeTask.totalTimeSpent + 1
        };
        
        // Update in memory for immediate UI feedback
        updateTask(updatedTask);
      }, 1000);

    } else {
      // Clear interval when timer stops or conditions change
      if (intervalRef.current) {
        console.log('Stopping real-time task time tracking');
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    // Cleanup on unmount or dependency change
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isRunning, timerType, activeTask?.id, updateTask]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);
};
